export default "__VITE_ASSET__DYXdpGmP__"